module.exports = __webpack_public_path__ + "static/media/background-text.4cc316f8.jpg";